<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<ng-container *transloco="let t">
  @if (sortedBrands$ | async; as brands) {
    <section class="product-brand-selector-component" [class.pill-mode]="pillMode">
      <nav
        class="nav"
        [class.mobile-mode]="mobileMode"
        [class.list-mode]="gridMode"
        [class.small-mode]="smallMode">
        @if (!gridMode && !pillMode && !smallMode) {
          <span class="fixed-space-16" aria-hidden="true"></span>
        }
        @for (brand of brands | slice: 0 : 10; track brand) {
          <a
            class="link"
            (click)="switchBrandFilter(brand)"
            [class.selected]="phoneFilterOptions?.brands?.includes(brand)">
            <!-- <div class="icon">{{ brand }}</div> -->
            <!--   <ng-container *ngIf="brand !== 'AMET' && brand !== 'Gizmo'">
            <img class="logo icon" [src]="getImageUrl(brand)" [alt]="brand" />
          </ng-container>
          <ng-container *ngIf="brand === 'AMET' || brand === 'Gizmo'"
            ><span>{{ brand }}</span>
          </ng-container> -->
            <app-brand-icon-picture
              class="logo icon brand"
              [smallMode]="smallMode"
              [pictureUrl]="getImageUrl(brand)"
              [width]="'80px'"
              [height]="'100px'"
              [alt]="brand">
            </app-brand-icon-picture>
          </a>
          <span aria-hidden="true" class="fixed-space-4"></span>
        }
      </nav>
    </section>
  } @else {
    <section class="product-brand-selector-component" [class.pill-mode]="pillMode">
      <nav class="nav" [class.mobile-mode]="mobileMode" [class.list-mode]="gridMode">
        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>
        <span aria-hidden="true" class="fixed-space-4"></span>
        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>
        <span aria-hidden="true" class="fixed-space-4"></span>
        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>
      </nav>
    </section>
  }
  <!-- eskeleton -->
  <ng-template #skeleton>
    <section class="product-brand-selector-component" [class.pill-mode]="pillMode">
      <nav class="nav" [class.mobile-mode]="mobileMode" [class.list-mode]="gridMode">
        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>

        <span aria-hidden="true" class="fixed-space-4"></span>

        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>

        <span aria-hidden="true" class="fixed-space-4"></span>

        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>
      </nav>
    </section>
  </ng-template>
</ng-container>
